import { render } from "./CustomerDetail.vue?vue&type=template&id=71abe2f2&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"

import "./CustomerDetail.vue?vue&type=style&index=0&id=71abe2f2&scoped=true&lang=css"
import "./CustomerDetail.vue?vue&type=style&index=1&id=71abe2f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71abe2f2"]])

export default __exports__